import OrdersIndex from './OrdersIndex';
import OrdersSettings from './OrdersSettings';
import OrdersSingle from './OrdersSingle';

export default function (app) {

    const settings = OrdersSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
        ],
    });

    OrdersIndex(app, settings);

    OrdersSingle(app, settings);

}